import React, { forwardRef, useImperativeHandle, useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '../../static/image/deleteIcon.svg';
import { setValueOtherProducts } from '../../redux/productSlice';
import CustomInput from '../../components/customInput/CustomInput';
import CommonDeleteModal from '../../components/commonDeleteModal/CommonDeleteModal';
import { fetchProductOptions } from '../../redux/productsSlice';

const OtherProducts = forwardRef(({ language }, ref) => {
  const dispatch = useDispatch();
  const productState = useSelector((state) => state.product);

  const productOptionsData = useSelector((state) => state.productList.productOptions);
  const product = productState.data || {};

  const otherProductsData = product.otherProducts || product.contentData?.otherProducts || {};
  const otherProductsItems = otherProductsData.items || [];
  const otherProductsTitle = otherProductsData.title || '';

  const [showDeleteProductModal, setShowDeleteProductModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);

  const productOptions = productOptionsData?.data?.[language]?.find(item => item.type === 'PRODUCT')?.codes || [];

  const PLACEHOLDER_CONFIG = {
    title: {
      EN: "Enter other products title EN",
      CN: "Enter other products title CN"
    },
    productTitle: {
      EN: "Enter product title EN",
      CN: "Enter product title CN"
    },
    productDescription: {
      EN: "Enter product description EN",
      CN: "Enter product description CN"
    },
    linkUrl: {
      EN: "Enter link URL EN",
      CN: "Enter link URL CN"
    },
  };

  const INITIAL_PRODUCT_ITEM = {
    title: '',
    description: '',
    url: ''
  };

  useEffect(() => {
    dispatch(fetchProductOptions());
  }, [dispatch]);

  useEffect(() => {
    if (!otherProductsData.title && otherProductsItems.length === 0) {
      dispatch(setValueOtherProducts({
        value: {
          title: '',
          items: [INITIAL_PRODUCT_ITEM]
        }
      }));
    }
  }, [otherProductsData, otherProductsItems.length, dispatch]);

  const addGroup = useCallback(() => {
    dispatch(setValueOtherProducts({
      value: {
        ...otherProductsData,
        items: [...otherProductsItems, INITIAL_PRODUCT_ITEM]
      }
    }));
  }, [otherProductsData, otherProductsItems, dispatch]);

  const deleteGroup = useCallback((index) => {
    if (otherProductsItems.length <= 1) {
      alert("At least retain one product item");
      return;
    }
    setProductToDelete(index);
    setShowDeleteProductModal(true);
  }, [otherProductsData, otherProductsItems, language, dispatch]);

  const handleConfirmDeleteProduct = useCallback(() => {
    if (productToDelete !== null) {
      const newItems = otherProductsItems.filter((_, i) => i !== productToDelete);
      dispatch(setValueOtherProducts({
        value: {
          ...otherProductsData,
          items: newItems
        }
      }));
    }
    setShowDeleteProductModal(false);
    setProductToDelete(null);
  }, [otherProductsData, otherProductsItems, productToDelete, dispatch]);

  const updateOtherProducts = useCallback((field, value) => {
    dispatch(setValueOtherProducts({
      value: { ...otherProductsData, [field]: value }
    }));
  }, [otherProductsData, dispatch]);

  const updateProductItem = useCallback((index, field, value) => {
    const newItems = otherProductsItems.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    dispatch(setValueOtherProducts({
      value: {
        ...otherProductsData,
        items: newItems
      }
    }));
  }, [otherProductsData, otherProductsItems, dispatch]);

  const updateProductItemWithTitle = useCallback((index, titleValue) => {

    const selectedProduct = productOptions.find(option => option.code === titleValue);

    const newItems = otherProductsItems.map((item, i) => {
      if (i === index) {
        const updatedItem = { ...item, title: titleValue };
        if (selectedProduct && selectedProduct.value) {
          updatedItem.url = selectedProduct.value;
        } else if (!titleValue) {
          updatedItem.url = '';
        }
        return updatedItem;
      }
      return item;
    });

    dispatch(setValueOtherProducts({
      value: {
        ...otherProductsData,
        items: newItems
      }
    }));
  }, [otherProductsData, otherProductsItems, productOptions, dispatch]);

  const validateAllOtherProducts = useCallback(() => ({}), []);

  useImperativeHandle(ref, () => ({
    addGroup,
    validateAllOtherProducts
  }));

  const renderProductItem = (item, index) => (
    <div key={index}>
      <div className="domain-group">
        <div className='package-input'>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <label>Product Title:</label>
          </div>

          <select
            value={item.title || ''}
            onChange={(e) => updateProductItemWithTitle(index, e.target.value)}
            style={{ width: '73%', padding: '8px', outline: 'none', border: '1px solid #ddd' }}
          >
            <option value="">Select a product</option>
            {productOptions.map((option) => (
              <option key={option.code} value={option.code}>
                {option.code}
              </option>
            ))}
          </select>
          <button
            className="icon-btn"
            onClick={() => deleteGroup(index)}
            style={{ marginLeft: '12px' }}
          >
            <img src={DeleteIcon} alt="Delete" className="campaign-delete-icon" />
          </button>

        </div>

        <div className='package-input'>
          <label>Product description:</label>
          <textarea
            placeholder={PLACEHOLDER_CONFIG.productDescription[language]}
            value={item.description || ''}
            onChange={(e) => updateProductItem(index, 'description', e.target.value)}
            rows={3}
            style={{ width: '73%' }}
          />
        </div>

        <div className='package-input'>
          <label>Link Url:</label>
          <input
            type="text"
            placeholder={PLACEHOLDER_CONFIG.linkUrl[language]}
            value={item.url || ''}
            onChange={(e) => updateProductItem(index, 'url', e.target.value)}
            style={{ width: '73%' }}
          />
        </div>
      </div>

      {index !== otherProductsItems.length - 1 && (
        <div
          style={{
            height: '0.5px',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            margin: '25px -40px',
            width: 'calc(100% + 80px)',
            display: 'block',
            boxSizing: 'border-box'
          }}
        />
      )}
    </div>
  );

  return (
    <div className="tab-package-container">
      <div className="domain-group">
        <div className='package-input'>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <label>Title:</label>
          </div>
          <CustomInput
            type="text"
            value={otherProductsTitle}
            onChange={(e) => updateOtherProducts('title', e.target.value)}
            placeholder={PLACEHOLDER_CONFIG.title[language]}
            customStyle={{ width: '73%' }}
          />
        </div>
      </div>

      <div
        style={{
          height: '0.5px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          margin: '25px -40px',
          width: 'calc(100% + 80px)',
          display: 'block',
          boxSizing: 'border-box'
        }}
      />

      {otherProductsItems.map(renderProductItem)}

      <CommonDeleteModal
        show={showDeleteProductModal}
        onHide={() => {
          setShowDeleteProductModal(false);
          setProductToDelete(null);
        }}
        onConfirm={handleConfirmDeleteProduct}
        title="Delete Product"
        instruction="Are you sure you want to delete this product item?"
      />
    </div>
  );
});

export default OtherProducts;